import { combineReducers } from 'redux';

import AppReducer from './app';
import CandidateReducer from './candidate';
import ElectionReducer from './election';
import FlaggedLinkReducer from './flagged-link';
import FlaggedTopicReducer from './flagged-topic';
import RaceReducer from './race';
import UserReducer from './user';
import VoterTurnoutReducer from './turnout';
import RoleReducer from './role';

const rootReducer = combineReducers({
  app: AppReducer,
  candidates: CandidateReducer,
  elections: ElectionReducer,
  flaggedLinks: FlaggedLinkReducer,
  flaggedTopics: FlaggedTopicReducer,
  races: RaceReducer,
  roles: RoleReducer,
  turnout: VoterTurnoutReducer,
  user: UserReducer,
});

export default rootReducer;
